import Button, {ButtonProps} from "@mui/material/Button";
import { continueButtonStyle } from "./CouponStyles";
import { useTheme, useMediaQuery, CircularProgress } from "@mui/material";

interface ContinueButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export const ContinueButton: React.FC<ContinueButtonProps> = ({ 
  children = 'Continuar', 
  isLoading = false,
  ...props
}: ContinueButtonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Button
      {...props}
      variant="contained" 
      disabled={isLoading || props.disabled}
      sx={{
        ...continueButtonStyle,
        width: isMobile ? '100%' : 'auto',
        minWidth: isMobile ? '100%' : '280px',
      }}
      startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : undefined}
    >
      {isLoading ? 'Procesando...' : children}
    </Button>
  );
};














